import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (window.EB && window.EB.Ballots) {
      window.EB.Ballots.showHiddenWriteIns();
    }
  }
}
